import { searchInvestorsPressRelease as investorsPressReleaseMapper } from '../helpers/filters/investors-press-release';
import { search } from './search';

export const FILTER_INVESTORS_PRESS_RELEASE_KEY =
  'investors-press-release-filter';
export const searchInvestorsPressRelease = search(investorsPressReleaseMapper);
